module.exports = __webpack_public_path__ + "static/media/chapter-completed.2af95e11.gif";